export default {
  email: {
    required: 'User email is required.',
    format: 'User email must be in a valid email format.',
  },
  loginId: {
    required: 'Username is required.',
    max: 'Username must be no more than 100 characters.',
    format: 'Username cannot be an email format.',
  },
  password: {
    required: 'Password is required.',
    format: 'Password must be at least 8 characters long and include numbers, lowercase letters, uppercase letters, and at least one [^$*.[]{}()?-"!@#%&/\\,><\':;|_~`+=].',
  },
  newPassword: {
    required: 'New password is required.',
    same: 'New password is the same as the current password.',
    mismatch: 'New password does not match the confirmation.',
  },
  confirmNewPassword: {
    required: 'Confirmation password is required.',
  },
  button: {
    type: 'Unsupported button type.',
    name: {
      required: 'Button name is required.',
      max: 'Button name must be no more than 14 characters.',
      disallowedVariable: 'Variables are not allowed in button names.',
    },
    mobileUrl: {
      required: 'Mobile web link is required.',
      url: 'Mobile web link must be a valid URL starting with http:// or https:// (app scheme links are not allowed).',
      max: 'Mobile web link must be no more than 500 characters.',
    },
    pcUrl: {
      max: 'PC web link must be no more than 500 characters.',
      url: 'PC web link must be a valid URL starting with http:// or https:// (app scheme links are not allowed).',
    },
    androidDeepLink: {
      required: 'Android app link is required.',
      max: 'Android app link must be no more than 500 characters.',
    },
    iosDeepLink: {
      required: 'iOS app link is required.',
      max: 'iOS app link must be no more than 500 characters.',
    },
    size: 'Up to 5 buttons can be set.',
    businessFormEnded: 'Business Form (BF) buttons are no longer supported per Kakao policy. Please change to a different button type.',
    businessFormName: 'The business form button name can only be entered as \'Take a survey in Talk\', \'Apply in Talk\', or \'Make a reservation in Talk\'.',
    bizFormKey: {
      required: 'Business ID is required.',
      disallowedVariable: 'Variables cannot be used in the Business ID.',
      enabledVariable: 'The Business ID contains a variable that is not allowed.',
    },
  },
  itemList: {
    title: {
      required: 'Item name in the item list is required.',
      max: 'Item name in the item list must be no more than 6 characters.',
      disallowedVariable: 'Variables are not allowed in item names.',
    },
    description: {
      required: 'Item content in the item list is required.',
      max: 'Item content in the item list must be no more than 23 characters.',
    },
    size: {
      min: 'At least 2 items must be set in the item list.',
      max: 'Up to 10 items can be set in the item list.',
    },
    highlight: {
      title: {
        required: 'Item highlight is enabled.\nPlease enter a highlight title.',
        max: 'Highlight title must be no more than 30 characters, or 21 characters if an image is added.',
        disallowedVariable: 'Variables are not allowed in highlight titles.',
      },
      description: {
        required: 'Item highlight is enabled.\nPlease enter highlight content.',
        max: 'Highlight content must be no more than 19 characters, or 13 characters if an image is added.',
      },
      image: {
        required: 'Item highlight image is enabled. Please upload an image.',
        uuid: 'Item highlight image ID must be in UUID format.',
      },
    },
    summary: {
      title: {
        required: 'Item summary info is enabled.\nPlease enter an info title.',
        max: 'Info title must be no more than 6 characters.',
        disallowedVariable: 'Variables are not allowed in info titles.',
      },
      description: {
        required: 'Item summary info is enabled.\nPlease enter info content.',
        max: 'Info content must be no more than 14 characters.',
        format: 'Only variables, currency symbols, numbers, commas, and periods are allowed in info content.',
      },
    },
    image: {
      required: 'Image usage is enabled.\nPlease upload an image.',
      uuid: 'Image ID must be in UUID format.',
    },
    header: {
      required: 'Header is enabled.\nPlease enter a header.',
      max: 'Header must be no more than 23 characters.',
    },
  },
  department: {
    name: {
      required: 'Department name is required.',
      max: 'Department name must be no more than 255 characters.',
    },
    code: {
      required: 'Department code is required.',
      max: 'Department code must be no more than 255 characters.',
    },
  },
  mfa: {
    code: {
      required: 'Verification code is required.',
      format: 'Verification code must be a 6-digit number.',
    },
  },
  kakaoProfile: { required: 'Kakao profile is required.' },
  templateName: {
    required: 'Template name is required.',
    max: 'Template name must be no more than 200 characters.',
  },
  content: {
    required: 'Template content is required.',
    max: 'Template content must be no more than 1,000 characters.',
  },
  messageType: 'Unsupported message type.',
  emphasizeType: 'Unsupported highlight type.',
  TEXT: {
    mainTitle: {
      max: 'Highlight title must be no more than 50 characters.',
      required: 'Highlight title is required.',
    },
    subTitle: {
      max: 'Highlight subtitle must be no more than 50 characters.',
      required: 'Highlight subtitle is required.',
      disallowedVariable: 'Variables are not allowed in highlight subtitles.',
    },
  },
  IMAGE: {
    image: {
      required: 'Highlight image is required.',
      uuid: 'Highlight image ID must be in UUID format.',
    },
  },
  EX: {
    extra: {
      required: 'Additional info is required for “Additional Info” type.',
      max: 'Additional info must be no more than 500 characters.',
      disallowedVariable: 'Variables are not allowed in additional info.',
    },
  },
  AD: {
    addChannel: 'The “Channel Add” type must include a “Channel Add” button.',
  },
  MI: {
    addChannel: 'The “Mixed” type must include a “Channel Add” button.',
    extra: {
      required: 'Additional info is required for “Mixed” type.',
      max: 'Additional info for “Mixed” type must be no more than 500 characters.',
      disallowedVariable: 'Variables are not allowed in additional info for “Mixed” type.',
    },
  },
  serviceName: {
    required: 'Service name is required.',
    max: 'Service name must be no more than 100 characters.',
  },
  administrator: {
    name: {
      required: 'User name is required.',
      max: 'User name must be no more than 100 characters.',
    },
    email: {
      required: 'Email is required.',
      customEmail: 'Email must be in a valid email format.',
    },
    securityPolicy: 'Security setting is required.',
    ip: {
      required: 'IP is required.',
      max: 'IP must be no more than 50 characters.',
    },
    comment: { max: 'Note must be no more than 100 characters.' },
  },
  inquiry: {
    file: {
      length: {
        max: 'You can upload up to 10 files for inquiry registration.',
      },
      size: { max: 'Each attachment must be less than 1MB.' },
      extension: 'Supported file formats: .png, .jpg, .jpeg, .gif, .pdf, .hwp, .doc, .docx',
      totalSize: { max: 'Total file size must be less than 5MB.' },
    },
    content: {
      required: 'Inquiry content is required.',
      max: 'Inquiry content must be no more than 300 characters.',
    },
  },
  rejectPhone: {
    id: {
      required: 'Opt-out number is required.',
      uuid: 'Opt-out number must be in UUID format.',
    },
    recipientNumber: {
      required: 'Customer ID is required.',
      max: 'Customer ID must be no more than 25 characters.',
    },
    comment: { max: 'Customer ID must be no more than 1,500 characters.' },
  },
  emailPassword: {
    mismatch: 'The entered username and email do not match. Please check again.',
  },
  mfaRequest: {
    toManyRequest: 'You have exceeded the authentication code request limit. Please try again later.',
  },
  image: {
    name: {
      required: 'Please enter an image name.',
      max: 'The image name must be 25 characters or fewer.',
    },
    mms: {
      size: 'The size of the MMS image must be 500KB or less.',
      extension: 'Only .jpg format is supported for MMS images.',
    },
    normal: {
      size: 'The size of a standard KakaoTalk image must be 500KB or less.',
      extension: 'Standard KakaoTalk images support only .jpg or .png formats.',
      width: {
        min: 'The width of a standard KakaoTalk image must be at least 500px.',
        max: 'The width of a standard KakaoTalk image must not exceed 4500px.',
      },
      height: {
        min: 'The height of a standard KakaoTalk image must be at least 250px.',
        max: 'The height of a standard KakaoTalk image must not exceed 4500px.',
      },
      ratio: {
        min: 'The aspect ratio of a standard KakaoTalk image must be between 2:1 and 3:4.',
        max: 'The aspect ratio of a standard KakaoTalk image must be between 2:1 and 3:4.',
      },
    },
    wide: {
      size: 'The size of a wide KakaoTalk image must be 5MB or less.',
      extension: 'Wide KakaoTalk images support only .jpg or .png formats.',
      width: {
        min: 'The width of a standard KakaoTalk image must be 800px and the height must be 600px.',
        max: 'The width of a standard KakaoTalk image must be 800px and the height must be 600px.',
      },
      height: {
        min: 'The width of a standard KakaoTalk image must be 800px and the height must be 600px.',
        max: 'The width of a standard KakaoTalk image must be 800px and the height must be 600px.',
      },
    },
    mainWideItemList: {
      size: 'The size of a main wide item list image must be 5MB or less.',
      extension: 'Main wide item list images support only .jpg or .png formats.',
      width: {
        min: 'The width of a main wide item list image must be at least 500px.',
        max: 'The width of a main wide item list image must not exceed 4500px.',
      },
      ratio: 'The width-to-height ratio of a main wide item list image must be 2:1.',
    },
    wideItemList: {
      size: 'The size of a wide item list image must be 5MB or less.',
      extension: 'Wide item list images support only .jpg or .png formats.',
      width: {
        min: 'The width of a wide item list image must be at least 500px.',
        max: 'The width of a wide item list image must not exceed 4500px.',
      },
      ratio: 'The width-to-height ratio of a wide item list image must be 1:1.',
    },
    carouselFeed: {
      size: 'The size of a carousel feed image must be 5MB or less.',
      extension: 'Carousel feed images support only .jpg or .png formats.',
      width: {
        min: 'The width of a carousel feed image must be at least 500px.',
        max: 'The width of a carousel feed image must not exceed 4500px.',
      },
      height: {
        max: 'The height of a carousel feed image must not exceed 4500px.',
      },
      ratio: {
        min: 'The aspect ratio of a carousel feed image must be between 2:1 and 3:4.',
        max: 'The aspect ratio of a carousel feed image must be between 2:1 and 3:4.',
      },
    },
    carouselCommerce: {
      size: 'The size of a carousel commerce image must be 5MB or less.',
      extension: 'Carousel commerce images support only .jpg or .png formats.',
      width: {
        min: 'The width of a carousel commerce image must be at least 500px.',
        max: 'The width of a carousel commerce image must not exceed 4500px.',
      },
      height: {
        max: 'The height of a carousel commerce image must not exceed 4500px.',
      },
      ratio: {
        min: 'The aspect ratio of a carousel commerce image must be between 2:1 and 3:4.',
        max: 'The aspect ratio of a carousel commerce image must be between 2:1 and 3:4.',
      },
    },
    alimtalk: {
      size: 'The size of an AlimTalk image must be 500KB or less.',
      extension: 'AlimTalk images support only .jpg or .png formats.',
      width: {
        min: 'The width of an AlimTalk image must be at least 500px.',
      },
      height: {
        min: 'The height of an AlimTalk image must be at least 250px.',
      },
      ratio: {
        min: 'The aspect ratio of an AlimTalk image must be exactly 2:1.',
        max: 'The aspect ratio of an AlimTalk image must be exactly 2:1.',
      },
    },
    alimtalkItemHighlight: {
      size: 'The size of a highlight thumbnail image must be 500KB or less.',
      extension: 'Highlight thumbnails support only .jpg or .png formats.',
      width: {
        min: 'The width of a highlight thumbnail image must be at least 108px.',
      },
      height: {
        min: 'The height of a highlight thumbnail image must be at least 108px.',
      },
      ratio: {
        min: 'The aspect ratio of a highlight thumbnail image must be exactly 1:1.',
        max: 'The aspect ratio of a highlight thumbnail image must be exactly 1:1.',
      },
    },
  },
  title: 'Notification',
};
